module.exports = {
  // 提案計画進捗状態
  proposalProgressStatus: [
    { code: 'enum_300', value: '300', text: '提案計画活動中' },
    { code: 'enum_330', value: '330', text: '提案計画未採用' },
    { code: 'enum_320', value: '320', text: '受注' },
    { code: 'enum_340', value: '340', text: '受注キャンセル' },
    { code: 'enum_400', value: '400', text: '納品完了' },
  ],
  // 見積ステータス
  estimateStatus: [
    { code: 'enum_580', value: '580', text: '見積登録中・見積変更中' },
    { code: 'enum_500', value: '500', text: '原価承認待ち' },
    { code: 'enum_501', value: '501', text: '原価承認保留中' },
    { code: 'enum_502', value: '502', text: '原価否決' },
    { code: 'enum_520', value: '520', text: '原価承認済' },
    { code: 'enum_530', value: '530', text: '原価再登録中' },
    { code: 'enum_540', value: '540', text: '原価再登録承認待ち　' },
    { code: 'enum_541', value: '541', text: '原価再登録承認保留中' },
    { code: 'enum_542', value: '542', text: '原価再登録否決' },
    { code: 'enum_600', value: '600', text: '見積承認待ち' },
    { code: 'enum_601', value: '601', text: '見積承認保留中' },
    { code: 'enum_602', value: '602', text: '見積否決' },
    { code: 'enum_610', value: '610', text: '原価見積承認待ち' },
    { code: 'enum_611', value: '611', text: '原価見積承認保留中' },
    { code: 'enum_612', value: '612', text: '原価見積否決' },
    { code: 'enum_620', value: '620', text: '見積承認済' },
    { code: 'enum_690', value: '690', text: '見積取消' },
  ],
  // 受注状態区分
  acceptOrderStatusClass: [
    { code: 'enum_0', value: '0', text: '提案前' },
    { code: 'enum_1', value: '1', text: '提案' },
    { code: 'enum_2', value: '2', text: '受注前' },
    { code: 'enum_3', value: '3', text: '受注' },
  ],
  // 受注ステータス
  acceptOrderStatus: [
    { code: 'enum_300', value: '300', text: '提案計画活動中' },
    { code: 'enum_330', value: '330', text: '提案計画未採用・受注取消' },
    { code: 'enum_110', value: '110', text: '受注登録中' },
    { code: 'enum_120', value: '120', text: '受注変更中' },
    { code: 'enum_140', value: '140', text: '受注ｷｬﾝｾﾙ中' },
    { code: 'enum_210', value: '210', text: '受注承認待ち' },
    { code: 'enum_211', value: '211', text: '受注承認保留中' },
    { code: 'enum_212', value: '212', text: '受注否決' },
    { code: 'enum_220', value: '220', text: '受注変更承認待ち' },
    { code: 'enum_221', value: '221', text: '受注変更保留中' },
    { code: 'enum_222', value: '222', text: '受注変更否決' },
    { code: 'enum_240', value: '240', text: '受注ｷｬﾝｾﾙ承認待ち' },
    { code: 'enum_241', value: '241', text: '受注ｷｬﾝｾﾙ保留中' },
    { code: 'enum_242', value: '242', text: '受注ｷｬﾝｾﾙ否決' },
    { code: 'enum_320', value: '320', text: '受注' },
    { code: 'enum_340', value: '340', text: '受注ｷｬﾝｾﾙ' },
    { code: 'enum_400', value: '400', text: '納品完了' },
  ],
  // 発注ステータス
  purchaseOrderStatus: [
    { code: 'enum_700', value: '700', text: '発注登録中' },
    { code: 'enum_710', value: '710', text: '発注変更中' },
    { code: 'enum_720', value: '720', text: '発注キャンセル中' },
    { code: 'enum_800', value: '800', text: '発注登録承認待ち ' },
    { code: 'enum_801', value: '801', text: '発注登録保留中' },
    { code: 'enum_802', value: '802', text: '発注登録否決' },
    { code: 'enum_810', value: '810', text: '発注変更承認待ち' },
    { code: 'enum_811', value: '811', text: '発注変更保留中' },
    { code: 'enum_812', value: '812', text: '発注変更否決' },
    { code: 'enum_820', value: '820', text: '発注キャンセル承認待ち' },
    { code: 'enum_821', value: '821', text: '発注キャンセル保留中' },
    { code: 'enum_822', value: '822', text: '発注キャンセル否決' },
    { code: 'enum_900', value: '900', text: '発注' },
    { code: 'enum_920', value: '920', text: '発注キャンセル' },
    { code: 'enum_730', value: '730', text: '発注廃止' },
  ],
  // 請求書敬称区分
  billTitleClass: [
    { code: 'enum_1', value: '1', text: '御中' },
    { code: 'enum_2', value: '2', text: '様' },
  ],
  // 提案対応レベル
  demandResponseLevel: [
    { code: 'enum_S', value: 'S', text: '危険・法令違反' },
    { code: 'enum_A', value: 'A', text: '１年以内対応' },
    { code: 'enum_B', value: 'B', text: '2～3年以内対応' },
    { code: 'enum_C', value: 'C', text: '4～5年以内対応' },
    { code: 'enum_D', value: 'D', text: '提案事項' },
    { code: 'enum_P', value: 'P', text: 'ﾍﾟﾝﾃﾞｨﾝｸﾞ' },
  ],
  // 取引先区分
  customerClass: [
    { code: 'enum_1', value: '1', text: '法人' },
    { code: 'enum_2', value: '2', text: 'グループ' },
    { code: 'enum_3', value: '3', text: '組合' },
    { code: 'enum_4', value: '4', text: '個人' },
  ],
  // 請求書出力区分(受注)
  acceptOrderInvoiceOutputClass: [
    { code: 'enum_1', value: '1', text: '請求書を金額変更時に出力' },
    { code: 'enum_2', value: '2', text: '請求書を発行(経理から直送)' },
    { code: 'enum_3', value: '3', text: '発行不要' },
    { code: 'enum_4', value: '4', text: '請求書を発行(拠点へ返送)' },
  ],
  // 請求支払区分
  billPayClass: [
    { code: 'enum_1', value: '1', text: '請求' },
    { code: 'enum_2', value: '2', text: '支払' },
    { code: 'enum_3', value: '3', text: '請求兼支払' },
    { code: 'enum_4', value: '4', text: '点検拠点登録用' },
    { code: 'enum_5', value: '5', text: '内製発注先' },
  ],
  // 分類
  classification: [
    { code: 'enum_01', value: '01', text: '受託新規' },
    { code: 'enum_02', value: '02', text: '受託改定' },
    { code: 'enum_90', value: '90', text: 'その他' },
  ],
  // 拠点区分
  baseClass: [
    { code: 'enum_E', value: 'E', text: '関東' },
    { code: 'enum_W', value: 'W', text: '関西' },
  ],
  // 引当完了区分
  depositFinishClass: [
    { code: 'enum_0', value: '0', text: '未入金' },
    { code: 'enum_1', value: '1', text: '一部入金' },
    { code: 'enum_2', value: '2', text: '満額入金' },
  ],
  // 工期区分
  constructionClass: [
    { code: 'enum_A', value: 'A', text: '開始日～終了日' },
    { code: 'enum_B', value: 'B', text: '契約の日から3ヶ月' },
    { code: 'enum_C', value: 'C', text: '契約の日から6ヶ月' },
    { code: 'enum_D', value: 'D', text: '発注より○ヶ月着工、○週間で竣工' },
    { code: 'enum_E', value: 'E', text: '契約の日から10ヶ月' },
    { code: 'enum_F', value: 'F', text: '診断日から○ヶ月' },
    { code: 'enum_G', value: 'G', text: '契約の日から1年間' },
  ],
  // 作成判断区分
  createJudgeClass: [
    { code: 'enum_blank', value: ' ', text: '直接提案計画' },
    { code: 'enum_1', value: '1', text: '手動' },
    { code: 'enum_2', value: '2', text: '自動' },
    { code: 'enum_3', value: '3', text: '移行' },
    { code: 'enum_4', value: '4', text: 'インポート（提案計画）' },
    { code: 'enum_5', value: '5', text: '直接受注' },
    { code: 'enum_6', value: '6', text: 'インポート（直接受注）' },
  ],
  // 作成状態フラグ
  createStateFlg: [
    { code: 'enum_10', value: '10', text: '提案計画登録中' },
    { code: 'enum_13', value: '13', text: '提案計画変更中' },
    { code: 'enum_30', value: '30', text: '提案計画活動中' },
    { code: 'enum_33', value: '33', text: '提案計画未採用' },
    { code: 'enum_32', value: '32', text: '受注' },
    { code: 'enum_34', value: '34', text: '受注キャンセル' },
    { code: 'enum_40', value: '40', text: '納品完了' },
  ],
  // 工事内容区分
  workDetailClass: [
    {
      code: 'enum_A',
      value: 'A',
      text: '別途受注者から交付された見積書のとおりとします。',
    },
    { code: 'enum_B', value: 'B', text: '添付の見積書のとおりとします。' },
    { code: 'enum_C', value: 'C', text: '明細のとおりとします。' },
  ],
  // 預金種別
  depositType: [
    { code: 'enum_1', value: '1', text: '普通預金' },
    { code: 'enum_2', value: '2', text: '当座預金' },
    { code: 'enum_9', value: '9', text: 'その他' },
  ],
  // 納期区分
  limitClass: [
    { code: 'enum_A', value: 'A', text: '契約の日から3ヶ月' },
    { code: 'enum_B', value: 'B', text: '契約の日から6ヶ月' },
    { code: 'enum_C', value: 'C', text: '日付指定' },
    { code: 'enum_D', value: 'D', text: '契約の日から1年' },
  ],
  // 採用区分
  adoptFlag: [
    { code: 'enum_1', value: '1', text: '採用' },
    { code: 'enum_9', value: '9', text: '不採用' },
  ],
  // 見積レベル
  estimateLevel: [
    { code: 'enum_A', value: 'A', text: 'A' },
    { code: 'enum_B', value: 'B', text: 'B' },
    { code: 'enum_C', value: 'C', text: 'C' },
    { code: 'enum_P', value: 'P', text: 'P' },
    { code: 'enum_N', value: 'N', text: 'N' },
  ],
  // 見積無区分
  noEstimateFlg: [
    {
      code: 'enum_1',
      value: '1',
      text: '見積無し（お客様発注書・納品書登録）',
    },
    { code: 'enum_blank', value: ' ', text: '見積あり' },
  ],
  // 見積書様式区分
  estimateStyleClass: [
    { code: 'enum_0', value: '0', text: '見積無し' },
    { code: 'enum_1', value: '1', text: '単票タイプ' },
    { code: 'enum_2', value: '2', text: '内訳明細タイプ' },
    { code: 'enum_3', value: '3', text: '元請工事タイプ' },
    { code: 'enum_4', value: '4', text: '調査・診断業務タイプ' },
    { code: 'enum_5', value: '5', text: 'コンサル業務タイプ' },
    { code: 'enum_6', value: '6', text: '監理業務タイプ' },
    { code: 'enum_7', value: '7', text: '検査業務タイプ' },
    { code: 'enum_8', value: '8', text: 'タイルタイプ' },
    { code: 'enum_A', value: 'A', text: '単票_建設業法対応' },
    { code: 'enum_B', value: 'B', text: '明細_建設業法対応' },
    { code: 'enum_C', value: 'C', text: '単票_建設業法先方' },
    { code: 'enum_D', value: 'D', text: '明細_建設業法先方' },
    { code: 'enum_E', value: 'E', text: '災害マニュアル' },
  ],
  // 設備分類
  facilityClass: [
    { code: 'enum_11', value: '11', text: '(点検)総合設備点検' },
    { code: 'enum_12', value: '12', text: '(緊急)総合設備点検' },
    { code: 'enum_19', value: '19', text: '(その他)総合設備点検' },
    { code: 'enum_21', value: '21', text: '(点検)消防設備点検' },
    { code: 'enum_22', value: '22', text: '(緊急)消防設備点検' },
    { code: 'enum_29', value: '29', text: '(その他)消防設備点検' },
    { code: 'enum_31', value: '31', text: '(点検)エレベータ設備' },
    { code: 'enum_32', value: '32', text: '(緊急)エレベータ設備' },
    { code: 'enum_39', value: '39', text: '(その他)エレベータ設備' },
    { code: 'enum_41', value: '41', text: '(点検)機械式駐車装置' },
    { code: 'enum_42', value: '42', text: '(緊急)機械式駐車装置' },
    { code: 'enum_49', value: '49', text: '(その他)機械式駐車装置' },
    { code: 'enum_51', value: '51', text: '(点検)浄化槽設備' },
    { code: 'enum_52', value: '52', text: '(緊急)浄化槽設備' },
    { code: 'enum_59', value: '59', text: '(その他)浄化槽設備' },
    { code: 'enum_61', value: '61', text: '(点検)防犯カメラ' },
    { code: 'enum_62', value: '62', text: '(緊急)防犯カメラ' },
    { code: 'enum_69', value: '69', text: '(その他)防犯カメラ' },
    {
      code: 'enum_70',
      value: '70',
      text: '1．計画修繕(長計にある工事又は役務)',
    },
    {
      code: 'enum_71',
      value: '71',
      text: '2．改良工事(長計にない工事又は役務)',
    },
    { code: 'enum_72', value: '72', text: '3．点検 NG' },
    {
      code: 'enum_73',
      value: '73',
      text: '4．緊急対応(LN24手配など緊急対応案件全般)',
    },
    {
      code: 'enum_74',
      value: '74',
      text: '5．その他(1～4に該当しない工事又は役務、小修繕等)',
    },
    { code: 'enum_88', value: '88', text: '事後' },
    { code: 'enum_91', value: '91', text: '(点検)その他' },
    { code: 'enum_92', value: '92', text: '(緊急)その他' },
    { code: 'enum_99', value: '99', text: '(その他)その他' },
  ],
  // 発注書出力区分
  purchaseOrderOutputClass: [
    { code: 'enum_1', value: '1', text: '連絡書or発注書Ａ' },
    { code: 'enum_2', value: '2', text: '役務発注書' },
    { code: 'enum_5', value: '5', text: '役務発注書          ＋納品報告' },
    { code: 'enum_6', value: '6', text: '役務明細　　　　＋納品報告' },
    { code: 'enum_E', value: 'E', text: '建設業法' },
    { code: 'enum_F', value: 'F', text: '建設業法             ＋納品報告' },
    { code: 'enum_G', value: 'G', text: '建業明細' },
    { code: 'enum_H', value: 'H', text: '建業明細             ＋納品報告' },
    { code: 'enum_J', value: 'J', text: '専門                   ＋納品報告' },
    { code: 'enum_L', value: 'L', text: '工事部役務・診断＋納品報告' },
    { code: 'enum_N', value: 'N', text: 'タイル                ＋納品報告' },
    { code: 'enum_P', value: 'P', text: '移転・物販' },
    { code: 'enum_U', value: 'U', text: '建設業法並記' },
    { code: 'enum_V', value: 'V', text: '建設業法並記      ＋納品報告' },
    { code: 'enum_W', value: 'W', text: '建業明細並記' },
    { code: 'enum_X', value: 'X', text: '建業明細並記      ＋納品報告' },
    { code: 'enum_Y', value: 'Y', text: 'EVリニューアル  ＋納品報告' },
    { code: 'enum_9', value: '9', text: '発注書別途作成' },
  ],
  // 発生元識別区分
  originIdentClass: [
    { code: 'enum_0', value: '0', text: '販売管理' },
    { code: 'enum_1', value: '1', text: '伝票エントリー' },
    { code: 'enum_2', value: '2', text: '人事システム' },
    { code: 'enum_3', value: '3', text: 'SuperStream' },
    { code: 'enum_4', value: '4', text: '人件費原価' },
    { code: 'enum_9', value: '9', text: 'その他' },
  ],
  // 産廃取扱い区分
  industryTrashHandlingFlg: [
    {
      code: 'enum_A',
      value: 'A',
      text: '別途指示書に基づき、発注者の指定場所へ運搬',
    },
    { code: 'enum_B', value: 'B', text: '現地指定場所へ保管' },
    { code: 'enum_Z', value: 'Z', text: 'その他(任意入力)' },
  ],
  // お知らせ区分
  infoClass: [
    { code: 'enum_1', value: '1', text: '掲示' },
    { code: 'enum_2', value: '2', text: 'ビラのポスティング' },
    { code: 'enum_3', value: '3', text: 'しない' },
    { code: 'enum_4', value: '4', text: '掲示・ビラのポスティング' },
  ],
  // 業務形態
  consignmentWorkClass: [
    { code: 'enum_0', value: '0', text: '建設工事' },
    { code: 'enum_1', value: '1', text: '役務' },
    { code: 'enum_2', value: '2', text: '受託' },
  ],
  // 受注区分ｃｄ
  acceptOrderClassCd: [
    { code: 'enum_A', value: 'A', text: '当期受注&当期全額売上計上' },
    { code: 'enum_B', value: 'B', text: '当期一部売上計上' },
    { code: 'enum_C', value: 'C', text: '受注繰越（売上計上なし）' },
    { code: 'enum_D', value: 'D', text: 'Bからの変化のみ　' },
  ],
  // ｋｅｙ種別
  keyClass: [
    { code: 'enum_HB', value: 'HB', text: '被請求書作成' },
    { code: 'enum_LB', value: 'LB', text: '総合設備リスト' },
    { code: 'enum_RJ', value: 'RJ', text: '引当受注ＮＯ' },
    { code: 'enum_RR', value: 'RR', text: '引当入金ＮＯ' },
    { code: 'enum_RB', value: 'RB', text: '引当請求ＮＯ' },
    { code: 'enum_MT', value: 'MT', text: '取引先マスタ' },
  ],
  // 金額ゼロ種別
  priceZeroClass: [
    { code: 'enum_S', value: 'S', text: 'サービス(無償提供)' },
    { code: 'enum_C', value: 'C', text: '受注後のキャンセル' },
    { code: 'enum_T', value: 'T', text: '提案計画・受注の取消' },
    { code: 'enum_G', value: 'G', text: '共通原価集計用' },
  ],
  // 内外区分
  inOutClass: [
    { code: 'enum_0', value: '0', text: '内製' },
    { code: 'enum_1', value: '1', text: '外製' },
    { code: 'enum_2', value: '2', text: '混在' },
  ],
  // 要否区分
  necessaryFlag: [
    { code: 'enum_1', value: '1', text: '要' },
    { code: 'enum_blank', value: ' ', text: '不要' },
  ],
  // 不要フラグ
  unnecessaryFlag: [
    { code: 'enum_1', value: '1', text: '不要' },
    { code: 'enum_blank', value: ' ', text: '要' },
  ],
  // 真偽区分
  boolFlag: [
    { code: 'enum_1', value: '1', text: '真' },
    { code: 'enum_blank', value: ' ', text: '偽' },
  ],
  // 有無区分
  existFlag: [
    { code: 'enum_1', value: '1', text: '有' },
    { code: 'enum_blank', value: ' ', text: '無' },
  ],
  // 有無区分2
  existFlag2: [
    { code: 'enum_1', value: '1', text: 'あり' },
    { code: 'enum_blank', value: ' ', text: 'なし' },
  ],
  // 発注作成区分
  generationClass: [
    { code: 'enum_1', value: '1', text: '自動生成' },
    { code: 'enum_0', value: '0', text: '通常' },
  ],
  // 納品後請求フラグ
  afterDeliveryBillFlg: [
    { code: 'enum_1', value: '1', text: '納品後請求' },
    { code: 'enum_blank', value: ' ', text: '納品前請求' },
  ],
  // 印鑑区分
  stampClass: [
    { code: 'enum_1', value: '1', text: '角印' },
    { code: 'enum_2', value: '2', text: '丸印' },
  ],
  // 消費税計算区分
  consumptionTaxCalClass: [
    {
      code: 'enum_1',
      value: '1',
      text: '明細金額での消費税計算(以外のときは、従来どおりの合計金額での消費税計算となりまする)',
    },
  ],
  // 発注期間区分
  periodClass: [
    { code: 'enum_A', value: 'A', text: '開始日 ～ 終了日' },
    { code: 'enum_B', value: 'B', text: '契約の日から６ヶ月' },
    { code: 'enum_C', value: 'C', text: '契約の日から３ヶ月' },
    { code: 'enum_Z', value: 'Z', text: 'その他' },
  ],
  // 作業予実区分
  planAndResultClass: [
    { code: 'enum_1', value: '1', text: '受注' },
    { code: 'enum_2', value: '2', text: 'お客様' },
  ],
  // 支払条件
  payCondition: [
    { code: 'enum_1', value: '1', text: '完成確認月月末締翌月20日支払' },
    { code: 'enum_2', value: '2', text: '完了報告書受領月月末締翌月末日支払' },
    {
      code: 'enum_3',
      value: '3',
      text: '完了報告書受領月月末締翌々月10日支払',
    },
    { code: 'enum_4', value: '4', text: '特例' },
    { code: 'enum_5', value: '5', text: '分割支払い' },
    { code: 'enum_6', value: '6', text: '支払先から設定' },
  ],
  // 工事記録簿ｽﾃｰﾀｽ(基本)
  constructionRecordStatusBase: [
    { code: 'enum_A01', value: 'A01', text: '提案計画登録(ｵﾝﾗｲﾝ)済み' },
    { code: 'enum_A02', value: 'A02', text: '提案計画登録(ｲﾝﾎﾟｰﾄ)済み' },
    { code: 'enum_A03', value: 'A03', text: '受注確認登録確認依頼中' },
    { code: 'enum_A04', value: 'A04', text: '受注確認登録中' },
    { code: 'enum_A05', value: 'A05', text: '見積採用・受注登録依頼中' },
    { code: 'enum_A06', value: 'A06', text: '見積採用・受注登録中' },
    { code: 'enum_A07', value: 'A07', text: '受注確認保留中' },
    { code: 'enum_A90', value: 'A90', text: '工事記録簿活動中' },
  ],
  // 工事記録簿ｽﾃｰﾀｽ(受注締結)
  constructionRecordStatusAcceptingOrderAllia: [
    { code: 'enum_A10', value: 'A10', text: '受注締結未登録' },
    { code: 'enum_A11', value: 'A11', text: '受注締結登録中' },
    { code: 'enum_A12', value: 'A12', text: '受注締結承認待ち' },
    { code: 'enum_A13', value: 'A13', text: '受注締結済' },
    { code: 'enum_A14', value: 'A14', text: '受注締結保留中' },
  ],
  // 工事記録簿ｽﾃｰﾀｽ(組合完了確認書)
  constructionRecordStatusUniFinishAck: [
    { code: 'enum_A20', value: 'A20', text: '組合完了確認書未登録' },
    { code: 'enum_A21', value: 'A21', text: '組合完了確認書登録中' },
    { code: 'enum_A22', value: 'A22', text: '組合完了確認書承認待ち' },
    { code: 'enum_A23', value: 'A23', text: '組合完了確認書確認済' },
    { code: 'enum_A24', value: 'A24', text: '組合完了確認書保留中' },
  ],
  // 工事記録簿ｽﾃｰﾀｽ(完了報告書)
  constructionRecordStatusFinishReport: [
    { code: 'enum_A30', value: 'A30', text: '完了報告書未登録' },
    { code: 'enum_A31', value: 'A31', text: '完了報告書登録中' },
    { code: 'enum_A32', value: 'A32', text: '完了報告書承認待ち' },
    { code: 'enum_A33', value: 'A33', text: '完了報告書済' },
    { code: 'enum_A34', value: 'A34', text: '完了報告書保留中' },
  ],
  // 工事記録簿ｽﾃｰﾀｽ(下請締結)
  constructionRecordStatusSubconAllia: [
    { code: 'enum_D10', value: 'D10', text: '下請締結未登録' },
    { code: 'enum_D11', value: 'D11', text: '下請締結登録中' },
    { code: 'enum_D12', value: 'D12', text: '下請締結承認待ち' },
    { code: 'enum_D13', value: 'D13', text: '下請締結済' },
    { code: 'enum_D14', value: 'D14', text: '下請締結保留中' },
  ],
  // 工事記録簿ｽﾃｰﾀｽ(下請完了)
  constructionRecordStatusSubconFinish: [
    { code: 'enum_D20', value: 'D20', text: '下請完了書類未登録' },
    { code: 'enum_D21', value: 'D21', text: '下請完了書類登録中' },
    { code: 'enum_D22', value: 'D22', text: '下請完了書類承認待ち' },
    { code: 'enum_D23', value: 'D23', text: '下請完了書類済' },
    { code: 'enum_D24', value: 'D24', text: '下請完了書類保留中' },
  ],
  // 発注保証書区分
  purchaseOrderWarrantyClass: [
    { code: 'enum_1', value: '1', text: '保証書あり' },
    { code: 'enum_2', value: '2', text: '保証書なし' },
    { code: 'enum_3', value: '3', text: '保証書未着' },
  ],
  // 工事記録簿ステータス（受注）
  constructionRecordStatusAcceptingOrder: [
    { code: 'enum_A03', value: 'A03', text: '受注確認登録確認依頼中' },
    { code: 'enum_A07', value: 'A07', text: '受注確認保留中' },
    { code: 'enum_A12', value: 'A12', text: '受注締結承認待ち' },
    { code: 'enum_A14', value: 'A14', text: '受注締結保留中' },
    { code: 'enum_A22', value: 'A22', text: '組合完了確認書承認待ち' },
    { code: 'enum_A24', value: 'A24', text: '組合完了確認書保留中' },
    { code: 'enum_A32', value: 'A32', text: '完了報告書承認待ち' },
    { code: 'enum_A34', value: 'A34', text: '完了報告書保留中' },
  ],
  // 工事記録簿ステータス（発注）
  constructionRecordStatusPurchaseOrder: [
    { code: 'enum_D12', value: 'D12', text: '下請締結承認待ち' },
    { code: 'enum_D14', value: 'D14', text: '下請締結保留中' },
    { code: 'enum_D22', value: 'D22', text: '下請完了書類承認待ち' },
    { code: 'enum_D24', value: 'D24', text: '下請完了書類保留中' },
  ],
  // 案件タイプ
  demandType: [
    { code: 'enum_1', value: '1', text: 'SC1' },
    { code: 'enum_2', value: '2', text: 'SC2' },
    { code: 'enum_3', value: '3', text: 'SC3' },
    { code: 'enum_4', value: '4', text: 'RC' },
    { code: 'enum_5', value: '5', text: 'RCS' },
    { code: 'enum_6', value: '6', text: 'RCS（スポット）' },
    { code: 'enum_7', value: '7', text: 'RCS（業務委託）' },
    { code: 'enum_x', value: 'x', text: 'その他' },
  ],
  // 印刷住所ｆ
  printAddressFlg: [
    { code: 'enum_1', value: '1', text: '発注者住所を「西新宿」にて印字' },
    { code: 'enum_2', value: '2', text: '発注者住所を「新大阪」にて印字' },
  ],
  // 被請求書発行フラグ
  printFlg: [
    { code: 'enum_1', value: '1', text: '作成済み' },
    { code: 'enum_2', value: '2', text: '発行完了' },
    { code: 'enum_3', value: '3', text: '原価計上済み' },
    { code: 'enum_4', value: '4', text: '再発行完了' },
  ],
  // 案件状況
  demandPhase: [
    { code: 'enum_10', value: '10', text: '提案計画 ' },
    { code: 'enum_20', value: '20', text: '見積協力依頼' },
    { code: 'enum_30', value: '30', text: '見積 ' },
    { code: 'enum_40', value: '40', text: '受注 ' },
    { code: 'enum_50', value: '50', text: '発注 ' },
    { code: 'enum_70', value: '70', text: '納品' },
    { code: 'enum_80', value: '80', text: '案件終了' },
    { code: 'enum_90', value: '90', text: '案件中止' },
  ],
  // 実施周期
  implementationCycle: [
    { code: 'enum_01', value: '01', text: '1年' },
    { code: 'enum_02', value: '02', text: '2年　' },
    { code: 'enum_03', value: '03', text: '3年　' },
    { code: 'enum_04', value: '04', text: '4年　' },
    { code: 'enum_05', value: '05', text: '5年' },
    { code: 'enum_06', value: '06', text: '6年　' },
    { code: 'enum_07', value: '07', text: '7年' },
    { code: 'enum_08', value: '08', text: '8年　' },
    { code: 'enum_09', value: '09', text: '9年　' },
    { code: 'enum_10', value: '10', text: '10年' },
  ],
  // 未採用フラグ
  unAdoptedFlg: [
    { code: 'enum_01', value: '01', text: '仕様変更' },
    { code: 'enum_02', value: '02', text: '提案したが先方の意向で先送り' },
    { code: 'enum_03', value: '03', text: '提案せずに先送り' },
    { code: 'enum_04', value: '04', text: '他社受注' },
    { code: 'enum_05', value: '05', text: '計画が白紙' },
    { code: 'enum_06', value: '06', text: '実施済' },
    { code: 'enum_07', value: '07', text: 'ＳＣ１へ移行' },
    { code: 'enum_08', value: '08', text: 'ＳＣ２へ移行' },
    { code: 'enum_09', value: '09', text: '他案件と合体' },
    { code: 'enum_10', value: '10', text: '重複計上' },
    { code: 'enum_99', value: '99', text: 'その他(管理解約等)' },
  ],
  // 取消フラグ
  cancelFlg: [
    { code: 'enum_1', value: '1', text: '取消' },
    { code: 'enum_blank', value: ' ', text: '有効' },
  ],
  // 非課税フラグ
  noTaxFlg: [
    { code: 'enum_1', value: '1', text: '非課税' },
    { code: 'enum_blank', value: ' ', text: '課税' },
  ],
  // 完了フラグ
  finishFlg: [
    { code: 'enum_blank', value: ' ', text: '未完了' },
    { code: 'enum_1', value: '1', text: '完了' },
  ],
  // 注文印刷住所フラグ
  printAdrsFlg: [
    { code: 'enum_1', value: '1', text: '見積住所を「虎ノ門」にて印字' },
    { code: 'enum_2', value: '2', text: '見積住所を「新大阪」にて印字' },
    {
      code: 'enum_3',
      value: '3',
      text: '見積印字部門を進行部門、見積住所を「虎ノ門」にて印字',
    },
    {
      code: 'enum_4',
      value: '4',
      text: '見積印字部門を進行部門、見積住所を「関西支社」にて印字',
    },
    {
      code: 'enum_5',
      value: '5',
      text: '見積印字部門、見積住所を「進行部門」にて印字',
    },
    {
      code: 'enum_6',
      value: '6',
      text: 'チェックなしの場合、見積印字部門、見積住所は計上部門',
    },
    {
      code: 'enum_7',
      value: '7',
      text: 'チェックなしの場合、見積印字部門、見積住所は進行部門',
    },
  ],
  // １円調整フラグ
  adj1yenFlg: [
    { code: 'enum_1', value: '1', text: '税端数（＋１）' },
    { code: 'enum_2', value: '2', text: '税端数（－１）' },
  ],
  // 緊急対応フラグ
  emergencySupportFlg: [
    { code: 'enum_1', value: '1', text: '緊急対応' },
    { code: 'enum_blank', value: ' ', text: '非緊急対応' },
  ],
  // 石綿対応
  asbestoContainFlg: [
    { code: 'enum_1', value: '1', text: '石綿含有' },
    { code: 'enum_blank', value: ' ', text: '石綿含有無' },
  ],
  // ｅｃｏ文書フラグ
  ecoDocFlg: [
    { code: 'enum_1', value: '1', text: '利用する' },
    { code: 'enum_blank', value: ' ', text: '利用しない' },
  ],
  // 連携フラグ
  alignFlg: [
    { code: 'enum_blank', value: ' ', text: '未連携' },
    { code: 'enum_1', value: '1', text: '連携済' },
    { code: 'enum_2', value: '2', text: 'アップロード済' },
    { code: 'enum_3', value: '3', text: 'ダウンロード済' },
  ],
  // 出力区分
  outputFlg: [
    { code: 'enum_1', value: '1', text: '出力' },
    { code: 'enum_blank', value: ' ', text: '未出力' },
  ],
  // 承認動作
  action: [
    { code: 'enum_0', value: '0', text: '承認申請' },
    { code: 'enum_1', value: '1', text: '承認' },
    { code: 'enum_2', value: '2', text: '否決' },
    { code: 'enum_3', value: '3', text: '保留' },
    { code: 'enum_4', value: '4', text: '承認取下' },
    { code: 'enum_5', value: '5', text: 'キャンセル申請' },
    { code: 'enum_6', value: '6', text: '申請取消' },
    { code: 'enum_7', value: '7', text: '差戾' },
  ],
  // プロセスインスタンスステータス
  procInstStatus: [
    { code: 'enum_0', value: '0', text: 'アクティブ' },
    { code: 'enum_1', value: '1', text: '保留中' },
    { code: 'enum_2', value: '2', text: '完了' },
  ],
  // 見積承認タイプ
  estimateType: [
    { code: 'enum_1', value: '1', text: '原価' },
    { code: 'enum_2', value: '2', text: '売価' },
    { code: 'enum_3', value: '3', text: '原価売価' },
    { code: 'enum_4', value: '4', text: '原価再登録' },
  ],
  // 請求予定月フラグ
  billPlanMonthFlg: [
    { code: 'enum_1', value: '1', text: '当月' },
    { code: 'enum_2', value: '2', text: '翌月' },
    { code: 'enum_3', value: '3', text: '前月' },
  ],
  // 入金予定月ｃｄ
  depositPlanMonthCd: [
    { code: 'enum_1', value: '1', text: '請求同月' },
    { code: 'enum_2', value: '2', text: '請求翌月' },
    { code: 'enum_3', value: '3', text: '請求翌々月' },
    { code: 'enum_4', value: '4', text: '請求翌翌々月' },
    { code: 'enum_5', value: '5', text: '請求の4ヶ月後' },
  ],
  // 請求出力方法
  billOutputClass: [
    { code: 'enum_1', value: '1', text: '日次' },
    { code: 'enum_2', value: '2', text: '月次' },
    { code: 'enum_3', value: '3', text: '個別' },
  ],
  // ｍｓ会計取得済フラグ
  msAccountAcquiredFlag: [
    { code: 'enum_1', value: '1', text: '取得待ち' },
    { code: 'enum_2', value: '2', text: '取得済み' },
  ],
  // 受託作業区分
  entrustedWorkFlag: [
    { code: 'enum_0', value: '0', text: '受託契約以外' },
    { code: 'enum_1', value: '1', text: '受託契約' },
  ],
  // 採番区分
  sequenceDivision: [
    { code: 'enum_1', value: '1', text: '案件' },
    { code: 'enum_2', value: '2', text: '提案計画' },
    { code: 'enum_3', value: '3', text: '受注' },
    { code: 'enum_4', value: '4', text: '作業' },
    { code: 'enum_5', value: '5', text: '被請求' },
    { code: 'enum_6', value: '6', text: '印刷リクエスト' },
  ],
  // 有効フラグ
  validFlg: [
    { code: 'enum_0', value: '0', text: '無効' },
    { code: 'enum_1', value: '1', text: '有効' },
  ],
  // 無効フラグ
  invalidFlg: [
    { code: 'enum_1', value: '1', text: '無効' },
    { code: 'enum_blank', value: ' ', text: '有効' },
  ],
  // 終了もの含む
  finishedContainFlag: [
    { code: 'enum_1', value: '1', text: '終了したものを含まない' },
    { code: 'enum_2', value: '2', text: '終了したものを含む' },
  ],
  // 権限タイプ
  permissionType: [
    { code: 'enum_0', value: '0', text: '照会' },
    { code: 'enum_1', value: '1', text: '更新' },
    { code: 'enum_2', value: '2', text: '照会と更新' },
  ],
  // 提案計画反映フラグ
  proposalApplyFlg: [
    { code: 'enum_1', value: '1', text: '反映済' },
    { code: 'enum_0', value: '0', text: '未反映' },
  ],
  // 勤務仕様
  knmmcd: [
    { code: 'enum_00', value: '00', text: '未登録　' },
    { code: 'enum_01', value: '01', text: '１回／週　' },
    { code: 'enum_02', value: '02', text: '２回／週　' },
    { code: 'enum_03', value: '03', text: '３回／週　' },
    { code: 'enum_04', value: '04', text: '４回／週　' },
    { code: 'enum_05', value: '05', text: '５回／週　' },
    { code: 'enum_06', value: '06', text: '６回／週　' },
    { code: 'enum_07', value: '07', text: '１回／隔週　' },
    { code: 'enum_08', value: '08', text: '１回／月　' },
    { code: 'enum_09', value: '09', text: '２回／月　' },
    { code: 'enum_10', value: '10', text: '３回／月　' },
    { code: 'enum_11', value: '11', text: '４回／月　  ' },
    { code: 'enum_12', value: '12', text: '２回／隔週' },
    { code: 'enum_13', value: '13', text: '７回／週　' },
    { code: 'enum_14', value: '14', text: '適宜（削除） ' },
    { code: 'enum_15', value: '15', text: '週３０時間　' },
    { code: 'enum_16', value: '16', text: 'シフト勤務' },
    { code: 'enum_17', value: '17', text: '週４０時間　' },
    { code: 'enum_99', value: '99', text: 'その他' },
  ],
  // 祝日フラグ
  hldf: [
    { code: 'enum_0', value: '0', text: '祝日は出勤' },
    { code: 'enum_1', value: '1', text: '祝日は休日' },
    { code: 'enum_2', value: '2', text: '休管の出勤' },
    { code: 'enum_3', value: '3', text: '休管の祝日は休日' },
    { code: 'enum_4', value: '4', text: '祝日のみ勤務' },
  ],
  // 排水制限
  drainageLimit: [
    { code: 'enum_0', value: '0', text: '排水停止' },
    { code: 'enum_1', value: '1', text: '排水ＯＫ' },
  ],
  // 産廃処理区分
  trashTreatDivision: [
    { code: 'enum_0', value: '0', text: '1対1' },
    { code: 'enum_1', value: '1', text: '少量' },
    { code: 'enum_2', value: '2', text: '無' },
    { code: 'enum_3', value: '3', text: 'フレコン' },
  ],
  // 作成状態フラグ
  crtstsf: [
    { code: 'enum_1', value: '1', text: '提案計画活動中として作成' },
    { code: 'enum_2', value: '2', text: '受注登録中として作成' },
    { code: 'enum_3', value: '3', text: '受注済みとして作成' },
  ],
  // 見積値引区分
  estimateDiscountType: [
    { code: 'enum_1', value: '1', text: '出精値引' },
    { code: 'enum_2', value: '2', text: '端数調整' },
  ],
  // エスカレーション承認区分
  escalationApprovalClass: [
    { code: 'enum_1', value: '1', text: 'エスカレーション承認' },
    { code: 'enum_blank', value: ' ', text: 'エスカレーション非承認' },
  ],
  // 原価ゼロ発注ｃフラグ
  costZeroFlg: [
    { code: 'enum_1', value: '1', text: '原価ゼロ発注書C作成' },
    { code: 'enum_blank', value: ' ', text: '原価ゼロ発注書C非作成' },
  ],
  // 産業廃棄物
  industryTrashFlg: [
    { code: 'enum_0', value: '0', text: '現地指定場所で保管' },
    { code: 'enum_1', value: '1', text: '指定場所へ運搬' },
  ],
  // 専任有無区分
  fullTimeClass: [
    { code: 'enum_1', value: '1', text: '専任なし' },
    { code: 'enum_2', value: '2', text: '専任あり' },
  ],
  // 主任監理区分
  chiefSuperClass: [
    { code: 'enum_1', value: '1', text: '主任' },
    { code: 'enum_2', value: '2', text: '監理' },
  ],
  // 工事記録簿受注拒否アクション
  constructionRecordAcceptOrderDenyAction: [
    { code: 'enum_0', value: '0', text: '否決なし' },
    { code: 'enum_1', value: '1', text: '受注確認否決' },
    { code: 'enum_2', value: '2', text: '受注締結否決' },
    { code: 'enum_3', value: '3', text: '完了報告書否決' },
    { code: 'enum_4', value: '4', text: '組合完了確認書否決' },
  ],
  // 工事記録簿発注拒否アクション
  constructionRecordOrderDenyAction: [
    { code: 'enum_0', value: '0', text: '否決なし' },
    { code: 'enum_1', value: '1', text: '下請締結否決' },
    { code: 'enum_2', value: '2', text: '下請完了否決' },
  ],
  // 不可フラグ
  canNotFlg: [
    { code: 'enum_1', value: '1', text: '不可' },
    { code: 'enum_0', value: '0', text: '可' },
  ],
  // 可否区分
  canFlg: [
    { code: 'enum_1', value: '1', text: '可' },
    { code: 'enum_0', value: '0', text: '不可' },
  ],
  // 計上部門区分
  accountingDepClass: [
    { code: 'enum_blank', value: ' ', text: '区分なし' },
    { code: 'enum_1', value: '1', text: '計上部門' },
  ],
  // 納品完了ステータス
  deliveryFinishStatus: [
    { code: 'enum_401', value: '401', text: '納品完了未登録' },
    { code: 'enum_402', value: '402', text: '納品完了登録中' },
    { code: 'enum_403', value: '403', text: '納品完了承認待ち' },
    { code: 'enum_400', value: '400', text: '納品完了' },
  ],
  // 一時ファイル区分
  tempFileType: [
    { code: 'enum_1', value: '1', text: '共通書類' },
    { code: 'enum_2', value: '2', text: '協力会社見積書類' },
    { code: 'enum_3', value: '3', text: '見積書類' },
    { code: 'enum_4', value: '4', text: '受注書類' },
    { code: 'enum_5', value: '5', text: '発注書類' },
    { code: 'enum_6', value: '6', text: '納品書類' },
  ],
  // 工事役務区分
  workServiceClass: [
    { code: 'enum_0', value: '0', text: '建設工事' },
    { code: 'enum_1', value: '1', text: '役務' },
  ],
  // 工事記録簿発注承認タイプ
  constructionRecordPurOrderType: [
    { code: 'enum_1', value: '1', text: '下請締結' },
    { code: 'enum_2', value: '2', text: '下請完了書類' },
  ],
  // 工事記録簿承認タイプ
  constructionRecordBaseType: [
    { code: 'enum_1', value: '1', text: '受注確認' },
    { code: 'enum_2', value: '2', text: '受注締結' },
    { code: 'enum_3', value: '3', text: '完了報告書' },
    { code: 'enum_4', value: '4', text: '組合完了確認書' },
  ],
  // 調査入力済フラグ
  surveyEnteredFlag: [
    { code: 'enum_1', value: '1', text: '入力済' },
    { code: 'enum_blank', value: ' ', text: '入力中' },
  ],
  // 担当区分
  chargeRole: [
    { code: 'enum_1', value: '1', text: 'メイン担当' },
    { code: 'enum_2', value: '2', text: 'サブ担当' },
  ],
  // 担当種別
  chargeType: [
    { code: 'enum_01', value: '01', text: '計上担当者' },
    { code: 'enum_02', value: '02', text: '進行担当者' },
    { code: 'enum_03', value: '03', text: '受注担当者(計画)' },
    { code: 'enum_04', value: '04', text: '診断担当者(管理)' },
    { code: 'enum_05', value: '05', text: '主任・監理技術者' },
    { code: 'enum_06', value: '06', text: '管理（推進）担当' },
  ],
  // 書類区分
  docClass: [
    { code: 'enum_01', value: '01', text: '工事用見積条件書' },
    { code: 'enum_02', value: '02', text: '役務用見積条件書' },
    { code: 'enum_08', value: '08', text: '日程調整連携資料（協力会社）' },
    { code: 'enum_09', value: '09', text: '日程調整連携資料（社内）' },
    { code: 'enum_10', value: '10', text: '現地調査依頼書類' },
    { code: 'enum_12', value: '12', text: 'SC2工事日程調整書類' },
    { code: 'enum_13', value: '13', text: 'SC3日程調整書類' },
    { code: 'enum_18', value: '18', text: '掲示物' },
    { code: 'enum_19', value: '19', text: '前日リマインド' },
    { code: 'enum_21', value: '21', text: 'SC1報告書' },
    { code: 'enum_22', value: '22', text: 'SC2報告書' },
    { code: 'enum_23', value: '23', text: 'SC3報告書' },
    { code: 'enum_24', value: '24', text: 'RCS（スポット）報告書' },
  ],
  // テンプレートcd
  mailTemplateCd: [
    { code: 'enum_T01', value: 'T01', text: '協力会社一括メール' },
    { code: 'enum_T02', value: 'T02', text: '準備アラートメール' },
    { code: 'enum_T03', value: 'T03', text: '報告書提出メール' },
    { code: 'enum_T04', value: 'T04', text: '対応不可メール' },
    { code: 'enum_T05', value: 'T05', text: '現地調査不要メール' },
    { code: 'enum_T06', value: 'T06', text: '作業可能日回答メール' },
    { code: 'enum_T07', value: 'T07', text: '日程提出一括催促メール' },
    { code: 'enum_T08', value: 'T08', text: '日程差戻メール' },
    {
      code: 'enum_T09',
      value: 'T09',
      text: '日程再調整メール（協力会社向け）',
    },
    { code: 'enum_T10', value: 'T10', text: '依頼書類提出一括催促メール' },
    { code: 'enum_T11', value: 'T11', text: '依頼書類提出催促メール' },
    { code: 'enum_T12', value: 'T12', text: '依頼書類差戻メール' },
    { code: 'enum_T13', value: 'T13', text: '着工広報リマインドメール' },
    { code: 'enum_T14', value: 'T14', text: '着工広報通知メール' },
    { code: 'enum_T15', value: 'T15', text: '掲示物登録メール' },
    { code: 'enum_T16', value: 'T16', text: '作業リマインドメール' },
    { code: 'enum_T17', value: 'T17', text: '報告書提出一括催促メール' },
    { code: 'enum_T18', value: 'T18', text: '報告書提出催促メール' },
    { code: 'enum_T19', value: 'T19', text: '報告書差戻メール' },
    { code: 'enum_T20', value: 'T20', text: '報告書連携メール' },
    { code: 'enum_T21', value: 'T21', text: '日程調整依頼取消メール' },
    { code: 'enum_T22', value: 'T22', text: '着工広報引戻メール' },
    { code: 'enum_T23', value: 'T23', text: '作業可能日依頼取消メール' },
    { code: 'enum_T24', value: 'T24', text: '作業予実未入力一括催促メール' },
    { code: 'enum_T25', value: 'T25', text: '日程調整依頼済メール' },
    { code: 'enum_T26', value: 'T26', text: '作業可能日依頼済メール' },
    {
      code: 'enum_T27',
      value: 'T27',
      text: '日程提出済（進行担当向け）メール',
    },
    { code: 'enum_T28', value: 'T28', text: '日程提出済（LC向け）メール' },
    {
      code: 'enum_T29',
      value: 'T29',
      text: '日程確認済（進行担当向け）メール',
    },
    { code: 'enum_T30', value: 'T30', text: '日程確認済（LC/FM向け）メール' },
    {
      code: 'enum_T31',
      value: 'T31',
      text: '日程確認済（協力会社向け）メール',
    },
    { code: 'enum_T32', value: 'T32', text: '見積共有資料メール' },
    { code: 'enum_T33', value: 'T33', text: '社内資料連携メール' },
    {
      code: 'enum_T34',
      value: 'T34',
      text: '作業日程マッチング済（協力会社向け）メール',
    },
    { code: 'enum_T35', value: 'T35', text: '依頼書類提出済メール' },
    { code: 'enum_T36', value: 'T36', text: '作業実績未入力一括催促メール' },
    { code: 'enum_T37', value: 'T37', text: '報告書未提出催促メール' },
    { code: 'enum_T38', value: 'T38', text: '作業予定日入力のお知らせ' },
    { code: 'enum_T39', value: 'T39', text: '作業予定日可否確認メール' },
    { code: 'enum_T40', value: 'T40', text: '作業予定日提出差戻メール' },
    { code: 'enum_T41', value: 'T41', text: 'RC報告書差戻メール' },
    { code: 'enum_T42', value: 'T42', text: '作業予定記入表' },
    { code: 'enum_T43', value: 'T43', text: '日程未記入リマインド(締め日前)' },
    { code: 'enum_T44', value: 'T44', text: '未記入プッシュ' },
    { code: 'enum_T45', value: 'T45', text: '不可日プッシュ' },
    { code: 'enum_T46', value: 'T46', text: '日程調整_DLN→協力会社' },
    { code: 'enum_T47', value: 'T47', text: '日程調整_協力会社→DLN' },
    { code: 'enum_T48', value: 'T48', text: '作業予定確認表' },
    { code: 'enum_T49', value: 'T49', text: '予定日広報' },
    { code: 'enum_T50', value: 'T50', text: '概要書完成通知メール' },
    {
      code: 'enum_T51',
      value: 'T51',
      text: '日程再調整メール（進行担当向け）',
    },
    { code: 'enum_T52', value: 'T52', text: '日程変更依頼取消メール' },
    { code: 'enum_T53', value: 'T53', text: '		報告書未提出一括催促メール' },
    { code: 'enum_T54', value: 'T54', text: '報告書未着のお知らせメール' },
    { code: 'enum_T55', value: 'T55', text: '正式版報告書未提出催促メール' },
    { code: 'enum_T56', value: 'T56', text: 'LCへ報告書未提出一括催促メール' },
    { code: 'enum_T57', value: 'T57', text: '作業変更日が入力済みのご連絡' },
    {
      code: 'enum_T58',
      value: 'T58',
      text: '日程変更依頼取消メール(進行担当向け)',
    },
    { code: 'enum_T59', value: 'T59', text: '作業日程確定のお知らせメール' },
    { code: 'enum_T60', value: 'T60', text: 'LCへ報告書未提出催促メール' },
    {
      code: 'enum_E01',
      value: 'E01',
      text: '見積条件書送信の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E02',
      value: 'E02',
      text: '見積原価承認依頼の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E03',
      value: 'E03',
      text: '見積登録依頼の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E04',
      value: 'E04',
      text: '原価承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E05',
      value: 'E05',
      text: '原価承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E06',
      value: 'E06',
      text: '原価承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E07',
      value: 'E07',
      text: '原価承認差戻の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E08',
      value: 'E08',
      text: '見積承認申請依頼の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E09',
      value: 'E09',
      text: '見積承認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E10',
      value: 'E10',
      text: '見積承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E11',
      value: 'E11',
      text: '見積承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E12',
      value: 'E12',
      text: '見積承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E13',
      value: 'E13',
      text: '見積承認差戻の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E14',
      value: 'E14',
      text: '原価再承認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_E15',
      value: 'E15',
      text: '見積採用の ご連絡(工事記録簿対象)',
    },
    { code: 'enum_E16', value: 'E16', text: '見積原価承認依頼の ご連絡' },
    { code: 'enum_E17', value: 'E17', text: '見積登録依頼の ご連絡' },
    { code: 'enum_E18', value: 'E18', text: '原価承認否決の ご連絡' },
    { code: 'enum_E19', value: 'E19', text: '原価承認保留の ご連絡' },
    { code: 'enum_E20', value: 'E20', text: '原価承認取下の ご連絡' },
    { code: 'enum_E21', value: 'E21', text: '原価承認差戻の ご連絡' },
    { code: 'enum_E22', value: 'E22', text: '見積承認申請依頼の ご連絡' },
    { code: 'enum_E23', value: 'E23', text: '見積承認完了の ご連絡' },
    { code: 'enum_E24', value: 'E24', text: '見積承認否決の ご連絡' },
    { code: 'enum_E25', value: 'E25', text: '見積承認保留の ご連絡' },
    { code: 'enum_E26', value: 'E26', text: '見積承認取下の ご連絡' },
    { code: 'enum_E27', value: 'E27', text: '見積承認差戻の ご連絡' },
    { code: 'enum_E28', value: 'E28', text: '原価再承認完了の ご連絡' },
    { code: 'enum_E29', value: 'E29', text: '見積採用の ご連絡' },
    {
      code: 'enum_E30',
      value: 'E30',
      text: '原価見積商品コード確認依頼の ご連絡',
    },
    {
      code: 'enum_E31',
      value: 'E31',
      text: '原価見積商品コード確認否決の ご連絡',
    },
    {
      code: 'enum_E32',
      value: 'E32',
      text: '原価見積商品コード確認保留の ご連絡',
    },
    { code: 'enum_E33', value: 'E33', text: '見積確認完了の ご連絡' },
    {
      code: 'enum_A01',
      value: 'A01',
      text: '受注確認承認依頼の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A02',
      value: 'A02',
      text: '見積採用・受注登録の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A03',
      value: 'A03',
      text: '受注確認承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A04',
      value: 'A04',
      text: '受注確認承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A05',
      value: 'A05',
      text: '受注確認承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A06',
      value: 'A06',
      text: '受注確認承認差戻の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A07',
      value: 'A07',
      text: '受注承認申請のご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A08',
      value: 'A08',
      text: '受注承認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A09',
      value: 'A09',
      text: '受注承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A10',
      value: 'A10',
      text: '受注承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A11',
      value: 'A11',
      text: '受注承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A12',
      value: 'A12',
      text: '受注承認差戻の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A13',
      value: 'A13',
      text: '受注変更承認申請のご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A14',
      value: 'A14',
      text: '受注変更承認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A15',
      value: 'A15',
      text: '受注変更承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A16',
      value: 'A16',
      text: '受注変更承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A17',
      value: 'A17',
      text: '受注変更承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A18',
      value: 'A18',
      text: '受注変更承認差戻の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A19',
      value: 'A19',
      text: '受注キャンセル承認申請の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A20',
      value: 'A20',
      text: '受注キャンセル承認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A21',
      value: 'A21',
      text: '受注キャンセル承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A22',
      value: 'A22',
      text: '受注キャンセル承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A23',
      value: 'A23',
      text: '受注キャンセル承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A24',
      value: 'A24',
      text: '受注キャンセル承認差戻の ご連絡(工事記録簿対象)',
    },
    { code: 'enum_A25', value: 'A25', text: '受注承認申請のご連絡' },
    { code: 'enum_A26', value: 'A26', text: '受注承認完了の ご連絡' },
    { code: 'enum_A27', value: 'A27', text: '受注承認否決の ご連絡' },
    { code: 'enum_A28', value: 'A28', text: '受注承認保留の ご連絡' },
    { code: 'enum_A29', value: 'A29', text: '受注承認取下の ご連絡' },
    { code: 'enum_A30', value: 'A30', text: '受注承認差戻の ご連絡' },
    { code: 'enum_A31', value: 'A31', text: '受注変更承認申請のご連絡' },
    { code: 'enum_A32', value: 'A32', text: '受注変更承認完了の ご連絡' },
    { code: 'enum_A33', value: 'A33', text: '受注変更承認否決の ご連絡' },
    { code: 'enum_A34', value: 'A34', text: '受注変更承認保留の ご連絡' },
    { code: 'enum_A35', value: 'A35', text: '受注変更承認取下の ご連絡' },
    { code: 'enum_A36', value: 'A36', text: '受注変更承認差戻の ご連絡' },
    { code: 'enum_A37', value: 'A37', text: '受注キャンセル承認申請の ご連絡' },
    { code: 'enum_A38', value: 'A38', text: '受注キャンセル承認完了の ご連絡' },
    { code: 'enum_A39', value: 'A39', text: '受注キャンセル承認否決の ご連絡' },
    { code: 'enum_A40', value: 'A40', text: '受注キャンセル承認保留の ご連絡' },
    { code: 'enum_A41', value: 'A41', text: '受注キャンセル承認取下の ご連絡' },
    { code: 'enum_A42', value: 'A42', text: '受注キャンセル承認差戻の ご連絡' },
    {
      code: 'enum_A43',
      value: 'A43',
      text: '受注締結登録確認依頼の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A44',
      value: 'A44',
      text: '受注締結登録確認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A45',
      value: 'A45',
      text: '受注締結承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A46',
      value: 'A46',
      text: '受注締結承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A47',
      value: 'A47',
      text: '受注締結承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_A48',
      value: 'A48',
      text: '受注締結承認差戻の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P01',
      value: 'P01',
      text: '発注承認申請の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P02',
      value: 'P02',
      text: '発注承認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P03',
      value: 'P03',
      text: '発注承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P04',
      value: 'P04',
      text: '発注承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P05',
      value: 'P05',
      text: '発注承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P06',
      value: 'P06',
      text: '発注承認差戻の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P07',
      value: 'P07',
      text: '発注変更承認申請のご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P08',
      value: 'P08',
      text: '発注変更承認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P09',
      value: 'P09',
      text: '発注変更承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P10',
      value: 'P10',
      text: '発注変更承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P11',
      value: 'P11',
      text: '発注変更承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P12',
      value: 'P12',
      text: '発注変更承認差戻の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P13',
      value: 'P13',
      text: '発注キャンセル承認申請の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P14',
      value: 'P14',
      text: '発注キャンセル承認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P15',
      value: 'P15',
      text: '発注キャンセル承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P16',
      value: 'P16',
      text: '発注キャンセル承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P17',
      value: 'P17',
      text: '発注キャンセル承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P18',
      value: 'P18',
      text: '発注キャンセル承認差戻の ご連絡(工事記録簿対象)',
    },
    { code: 'enum_P19', value: 'P19', text: '発注承認申請の ご連絡' },
    { code: 'enum_P20', value: 'P20', text: '発注承認完了の ご連絡' },
    { code: 'enum_P21', value: 'P21', text: '発注承認否決の ご連絡' },
    { code: 'enum_P22', value: 'P22', text: '発注承認保留の ご連絡' },
    { code: 'enum_P23', value: 'P23', text: '発注承認取下の ご連絡' },
    { code: 'enum_P24', value: 'P24', text: '発注承認差戻の ご連絡' },
    { code: 'enum_P25', value: 'P25', text: '発注変更承認申請のご連絡' },
    { code: 'enum_P26', value: 'P26', text: '発注変更承認完了の ご連絡' },
    { code: 'enum_P27', value: 'P27', text: '発注変更承認否決の ご連絡' },
    { code: 'enum_P28', value: 'P28', text: '発注変更承認保留の ご連絡' },
    { code: 'enum_P29', value: 'P29', text: '発注変更承認取下の ご連絡' },
    { code: 'enum_P30', value: 'P30', text: '発注変更承認差戻の ご連絡' },
    { code: 'enum_P31', value: 'P31', text: '発注キャンセル承認申請の ご連絡' },
    { code: 'enum_P32', value: 'P32', text: '発注キャンセル承認完了の ご連絡' },
    { code: 'enum_P33', value: 'P33', text: '発注キャンセル承認否決の ご連絡' },
    { code: 'enum_P34', value: 'P34', text: '発注キャンセル承認保留の ご連絡' },
    { code: 'enum_P35', value: 'P35', text: '発注キャンセル承認取下の ご連絡' },
    { code: 'enum_P36', value: 'P36', text: '発注キャンセル承認差戻の ご連絡' },
    {
      code: 'enum_P37',
      value: 'P37',
      text: '下請締結承認依頼の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P38',
      value: 'P38',
      text: '下請締結登録確認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P39',
      value: 'P39',
      text: '下請締結承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P40',
      value: 'P40',
      text: '下請締結承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P41',
      value: 'P41',
      text: '下請締結承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_P42',
      value: 'P42',
      text: '下請締結承認差戻の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D01',
      value: 'D01',
      text: '完了報告書承認依頼の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D02',
      value: 'D02',
      text: '完了報告書確認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D03',
      value: 'D03',
      text: '完了報告書承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D04',
      value: 'D04',
      text: '完了報告書承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D05',
      value: 'D05',
      text: '完了報告書承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D06',
      value: 'D06',
      text: '完了報告書承認差戻の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D07',
      value: 'D07',
      text: '組合完了確認書承認依頼の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D08',
      value: 'D08',
      text: '納品完了登録依頼の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D09',
      value: 'D09',
      text: '組合完了確認書承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D10',
      value: 'D10',
      text: '組合完了確認書承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D11',
      value: 'D11',
      text: '組合完了確認書承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D12',
      value: 'D12',
      text: '組合完了確認書承認差戻の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D13',
      value: 'D13',
      text: '納品完了登録承認申請の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D14',
      value: 'D14',
      text: '納品完了登録承認完了の ご連絡(工事記録簿対象)',
    },
    { code: 'enum_D15', value: 'D15', text: '納品完了登録承認申請の ご連絡' },
    { code: 'enum_D16', value: 'D16', text: '納品完了登録承認完了の ご連絡' },
    {
      code: 'enum_D17',
      value: 'D17',
      text: '下請完了書類承認依頼の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D18',
      value: 'D18',
      text: '下請完了書類登録確認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D19',
      value: 'D19',
      text: '下請完了書類承認否決の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D20',
      value: 'D20',
      text: '下請完了書類承認保留の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D21',
      value: 'D21',
      text: '下請完了書類承認取下の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D22',
      value: 'D22',
      text: '下請完了書類承認差戻の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D23',
      value: 'D23',
      text: '保証書登録完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D24',
      value: 'D24',
      text: '保証書登録確認完了の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D25',
      value: 'D25',
      text: '納品月変更の ご連絡(工事記録簿対象)',
    },
    {
      code: 'enum_D26',
      value: 'D26',
      text: '工期欄入力のお知らせの ご連絡(工事記録簿対象)',
    },
    { code: 'enum_O01', value: 'O01', text: '発注請書送付の ご連絡' },
    { code: 'enum_O02', value: 'O02', text: '注文書署名通知' },
  ],
  // 必須フラグ
  requiredFlg: [
    { code: 'enum_0', value: '0', text: '任意' },
    { code: 'enum_1', value: '1', text: '必須' },
  ],
  // 未決フラグ
  decidedFlag: [
    { code: 'enum_1', value: '1', text: '決定' },
    { code: 'enum_0', value: '0', text: '未決' },
    { code: 'enum_blank', value: ' ', text: 'N/A' },
  ],
  // 書類到着フラグ
  documentArrivalFlg: [
    { code: 'enum_1', value: '1', text: '到着' },
    { code: 'enum_0', value: '0', text: '未着' },
    { code: 'enum_blank', value: ' ', text: 'N/A' },
  ],
  // 操作タイプ
  operationType: [
    { code: 'enum_I', value: 'I', text: 'Insert' },
    { code: 'enum_U', value: 'U', text: 'Update' },
    { code: 'enum_D', value: 'D', text: 'Delete' },
  ],
  // 管理終了ｆ
  mngendf: [
    { code: 'enum_0', value: '0', text: '管理中' },
    { code: 'enum_1', value: '1', text: '管理終了' },
  ],
  // 受取フラグ
  receiptFlg: [
    { code: 'enum_1', value: '1', text: '受取済' },
    { code: 'enum_0', value: '0', text: '未受取' },
  ],
  // 確認フラグ
  confirmFlg: [
    { code: 'enum_1', value: '1', text: '確認済' },
    { code: 'enum_0', value: '0', text: '未確認' },
    { code: 'enum_blank', value: ' ', text: 'N/A' },
  ],
  // 承認クラスｃｄ
  autclscd: [
    { code: 'enum_C0', value: 'C0', text: 'GL' },
    { code: 'enum_C1', value: 'C1', text: '課長' },
    { code: 'enum_C2', value: 'C2', text: '部長' },
    { code: 'enum_C3', value: 'C3', text: '担当役員' },
    { code: 'enum_C4', value: 'C4', text: '事業部長' },
    { code: 'enum_C5', value: 'C5', text: '本部長' },
  ],
  // 工事記録簿登録モード
  constructionRecordApprovalMode: [
    { code: 'enum_1', value: '1', text: '受注確認登録モード' },
    { code: 'enum_2', value: '2', text: '受注締結登録モード' },
    { code: 'enum_3', value: '3', text: '完了報告書登録モード' },
    { code: 'enum_4', value: '4', text: '保証書登録モード' },
    { code: 'enum_5', value: '5', text: '組合完了確認書登録モード' },
  ],
  // 納品完了区分
  deliveryComplete: [
    { code: 'enum_1', value: '1', text: '非正常' },
    { code: 'enum_blank', value: ' ', text: '通常' },
  ],
  // 納品完了ステー
  deliveryCompleteStatus: [
    { code: 'enum_1', value: '1', text: '納品完了承認待ち' },
    { code: 'enum_2', value: '2', text: '納品完了保留中' },
  ],
  // 見積アクションモード
  estimateActionMode: [
    { code: 'enum_1', value: '1', text: '登録モード' },
    { code: 'enum_2', value: '2', text: '変更モード' },
    { code: 'enum_3', value: '3', text: '照会モード' },
    { code: 'enum_4', value: '4', text: '原価のみ変更モード' },
    { code: 'enum_5', value: '5', text: '見積のみ変更モード' },
  ],
  // 見積フロータイプ
  estimateFlowType: [
    {
      code: 'enum_1',
      value: '1',
      text: 'スタンダード承認＆工事記録簿基本存在しない',
    },
    {
      code: 'enum_2',
      value: '2',
      text: 'スタンダード承認＆工事記録簿基本存在して',
    },
    { code: 'enum_3', value: '3', text: 'エスカレーション承認' },
  ],
  // 発注入力モード
  purchaseOrderEntryMode: [
    { code: 'enum_1', value: '1', text: '登録モード' },
    { code: 'enum_2', value: '2', text: '承認前変更モード' },
    { code: 'enum_3', value: '3', text: '承認後変更モード' },
  ],
  // ステータス下請締結
  subcontractStatusSum: [
    { code: 'enum_0', value: '0', text: ' ' },
    { code: 'enum_1', value: '1', text: '下請締結登録中' },
    { code: 'enum_2', value: '2', text: '下請締結承認待ち' },
    { code: 'enum_3', value: '3', text: '下請締結済' },
    { code: 'enum_4', value: '4', text: '下請締結保留中' },
    { code: 'enum_5', value: '5', text: '承認待ちあり' },
  ],
  // ステータス下請完了
  completedSubcontractStatusSum: [
    { code: 'enum_0', value: '0', text: ' ' },
    { code: 'enum_1', value: '1', text: '下請完了書類登録中' },
    { code: 'enum_2', value: '2', text: '下請完了書類承認待ち' },
    { code: 'enum_3', value: '3', text: '下請完了書類済' },
    { code: 'enum_4', value: '4', text: '下請完了書類保留中' },
    { code: 'enum_5', value: '5', text: '承認待ちあり' },
  ],
  // タイル部斫り採取調査内容備考
  asbestosRemark1: [{ code: 'enum_1', value: '1', text: '機器損料、復旧含む' }],
  // 検体採取・分析調査内容備考
  asbestosRemark2: [
    { code: 'enum_1', value: '1', text: 'JIS A 1481-1に基づく' },
    { code: 'enum_2', value: '2', text: 'JIS A 1481-3に基づく' },
    { code: 'enum_3', value: '3', text: 'JIS A 1481-5に基づく' },
    { code: 'enum_4', value: '4', text: 'JIS A 1481-1及び5に基づく' },
  ],
  // 送信日付
  mailTime: [
    { code: 'enum_1', value: '1', text: '本日から 3日後' },
    { code: 'enum_2', value: '2', text: '本日から 6日後' },
    { code: 'enum_3', value: '3', text: '本日から 12日後' },
  ],
  // 提案計画へ反映
  proposalApply: [
    { code: 'enum_0', value: '0', text: '反映しない' },
    { code: 'enum_1', value: '1', text: '反映する' },
  ],
  // 建物管理形態
  manageForm: [
    { code: 'enum_1', value: '1', text: '住込' },
    { code: 'enum_2', value: '2', text: '通勤' },
    { code: 'enum_3', value: '3', text: '巡回' },
    { code: 'enum_4', value: '4', text: '常駐' },
    { code: 'enum_5', value: '5', text: '非常駐' },
    { code: 'enum_6', value: '6', text: 'フロントキーパー' },
    { code: 'enum_7', value: '7', text: '巡回清掃管理員' },
    { code: 'enum_8', value: '8', text: 'ＳＦＭ' },
    { code: 'enum_9', value: '9', text: 'その他' },
  ],
  // 納期区分2
  limitClass2: [
    { code: 'enum_A', value: 'A', text: '開始日～終了日' },
    { code: 'enum_B', value: 'B', text: '契約の日から3ヶ月' },
    { code: 'enum_C', value: 'C', text: '契約の日から6ヶ月' },
    { code: 'enum_D', value: 'D', text: '契約の日から1年' },
    { code: 'enum_Z', value: 'Z', text: 'その他(任意)' },
  ],
  // 建物管理状態区分
  bulidingManageStatus: [
    { code: 'enum_1', value: '1', text: '登録中' },
    { code: 'enum_2', value: '2', text: '有効' },
    { code: 'enum_3', value: '3', text: '変更中' },
    { code: 'enum_8', value: '8', text: '取消' },
    { code: 'enum_9', value: '9', text: '終了' },
  ],
  // 発生元区分
  originClass: [
    { code: 'enum_1', value: '1', text: '新規データ' },
    { code: 'enum_2', value: '2', text: '改定データ' },
    { code: 'enum_3', value: '3', text: '移行データ' },
  ],
  // ｃｌ請負フラグ
  clContractFlag: [
    { code: 'enum_1', value: '1', text: '元請' },
    { code: 'enum_2', value: '2', text: '非元請' },
  ],
  // 印刷状況
  printSts: [
    { code: 'enum_10', value: '10', text: '印刷データ転送完了' },
    { code: 'enum_20', value: '20', text: '印刷開始' },
    { code: 'enum_30', value: '30', text: '印刷中' },
    { code: 'enum_40', value: '40', text: '印刷成功' },
    { code: 'enum_50', value: '50', text: '印刷失敗' },
  ],
  // ダウンロード状況
  dlSts: [
    { code: 'enum_0', value: '0', text: '未ダウンロード　' },
    { code: 'enum_1', value: '1', text: 'ダウンロード済' },
  ],
  // 依頼区分
  requestClass: [
    { code: 'enum_1', value: '1', text: '事前調査' },
    { code: 'enum_2', value: '2', text: '工事・作業' },
  ],
  // 日程調整状況
  adjScheduleStatus: [
    { code: 'enum_1', value: '1', text: '未提出' },
    { code: 'enum_2', value: '2', text: '提出済み' },
    { code: 'enum_3', value: '3', text: '催促中' },
    { code: 'enum_4', value: '4', text: '調整済み' },
    { code: 'enum_5', value: '5', text: '差し戻し' },
    { code: 'enum_6', value: '6', text: '再調整' },
  ],
  // 書類提出状況
  docSubmitStatus: [
    { code: 'enum_1', value: '1', text: '未提出' },
    { code: 'enum_2', value: '2', text: '提出済み' },
    { code: 'enum_3', value: '3', text: '催促中' },
    { code: 'enum_4', value: '4', text: '確認済み' },
    { code: 'enum_5', value: '5', text: '差し戻し' },
    { code: 'enum_6', value: '6', text: '確認済み（更新あり）' },
    { code: 'enum_7', value: '7', text: '確認済み（移動済み）' },
    { code: 'enum_8', value: '8', text: '確認済み（削除済み）' },
  ],
  // 現地調整確認フラグ
  localAdjFlg: [
    { code: 'enum_0', value: '0', text: '未実施' },
    { code: 'enum_1', value: '1', text: '確認済み' },
  ],
  // 消防協議実施フラグ
  fireConsultationFlg: [
    { code: 'enum_0', value: '0', text: '未実施' },
    { code: 'enum_1', value: '1', text: '実施済み' },
  ],
  // 選定フラグ
  selectFlg: [
    { code: 'enum_0', value: '0', text: '未選定' },
    { code: 'enum_1', value: '1', text: '選定' },
  ],
  // 着工広報ステータス
  startPosterStatus: [
    { code: 'enum_1', value: '1', text: '起案中' },
    { code: 'enum_2', value: '2', text: '工事計画担当者処理中' },
    { code: 'enum_3', value: '3', text: '工事担当確認中' },
    { code: 'enum_4', value: '4', text: 'LC処理中' },
    { code: 'enum_5', value: '5', text: '庶務確認中' },
    { code: 'enum_6', value: '6', text: 'PS課処理中' },
    { code: 'enum_7', value: '7', text: '完了' },
  ],
  // 工事分類ｃｄ
  constructClassCd: [
    { code: 'enum_1', value: '1', text: '大規模' },
    { code: 'enum_2', value: '2', text: '塗装（鉄部）' },
    { code: 'enum_3', value: '3', text: '立駐塗装' },
    { code: 'enum_4', value: '4', text: '立駐埋戻し' },
    { code: 'enum_5', value: '5', text: '管（増圧、ライニング、管更新など）' },
    { code: 'enum_6', value: '6', text: 'インターホン' },
    { code: 'enum_7', value: '7', text: 'それ以外' },
    {
      code: 'enum_8',
      value: '8',
      text: 'エレベーター更新、機械駐入替等（機械器具設置）',
    },
  ],
  // 実施可能区分
  implementClass: [
    { code: 'enum_1', value: '1', text: '不可能' },
    { code: 'enum_2', value: '2', text: '可能であるが、できれば工期外を希望' },
    { code: 'enum_3', value: '3', text: '可能' },
  ],
  // 実施可能参考
  implementRef: [
    { code: 'enum_1', value: '1', text: '◎　' },
    { code: 'enum_21', value: '21', text: '○' },
    {
      code: 'enum_22',
      value: '22',
      text: '○（特建がある場合は×・雑排同日実施の場合は要拠点判断）　',
    },
    {
      code: 'enum_23',
      value: '23',
      text: '○（雑排同日実施の場合は要拠点判断）',
    },
    { code: 'enum_31', value: '31', text: '△' },
    { code: 'enum_32', value: '32', text: '△（内容要確認の上判断）　' },
    {
      code: 'enum_33',
      value: '33',
      text: '△（調整時は品質管理チームに相談）　',
    },
    {
      code: 'enum_34',
      value: '34',
      text: '△（避難ハッチなどが点検できるかで判断・雑排同日実施の場合は要拠点判断）',
    },
    { code: 'enum_41', value: '41', text: '×' },
    { code: 'enum_42', value: '42', text: '×（同日もの要確認）　' },
    {
      code: 'enum_43',
      value: '43',
      text: '×（清掃日の指定がコメントで日曜限定など、工事日に関係ない場合は実施可。同日もの要確認）',
    },
    {
      code: 'enum_44',
      value: '44',
      text: '×（雑排同日実施の場合は要拠点判断）',
    },
  ],
  // 実施の判断
  implementJudge: [
    { code: 'enum_1', value: '1', text: '中止' },
    { code: 'enum_2', value: '2', text: '工期前実施希望' },
    { code: 'enum_3', value: '3', text: '工期後実施希望' },
    { code: 'enum_4', value: '4', text: '予定通り実施' },
  ],
  // 実施月
  implementMonth: [
    { code: 'enum_1', value: '1', text: '当初設定月中を希望' },
    { code: 'enum_2', value: '2', text: '設定月外でも可能' },
  ],
  // 同日実施
  samedayImplement: [
    { code: 'enum_1', value: '1', text: '一緒にずらす' },
    { code: 'enum_2', value: '2', text: 'ずらさない' },
  ],
  // 点検実施範囲
  inspecteScope: [
    { code: 'enum_1', value: '1', text: '変更無し' },
    { code: 'enum_2', value: '2', text: '範囲を縮小または変更して実施' },
  ],
  // 可能日依頼状況
  requestStatus: [
    { code: 'enum_1', value: '1', text: '未提出 ' },
    { code: 'enum_2', value: '2', text: '催促中' },
    { code: 'enum_3', value: '3', text: '提出済み' },
  ],
  // 依頼有無
  requestExist: [
    { code: 'enum_0', value: '0', text: '未依頼' },
    { code: 'enum_1', value: '1', text: '依頼済み' },
  ],
  // イベント区分
  eventClass: [{ code: 'enum_01', value: '01', text: '日程調整' }],
  // 調整元区分
  adjSourceClass: [
    { code: 'enum_1', value: '1', text: '協力会社' },
    { code: 'enum_2', value: '2', text: 'DLN' },
  ],
  // 調査要否
  investigationFlg: [
    { code: 'enum_1', value: '1', text: '要' },
    { code: 'enum_0', value: '0', text: '不要' },
    { code: 'enum_blank', value: ' ', text: '未指定' },
  ],
  // 依頼対応区分
  dealingFlg: [
    { code: 'enum_1', value: '1', text: '日程調整要' },
    { code: 'enum_0', value: '0', text: '日程調整不要' },
    { code: 'enum_2', value: '2', text: '対応不可' },
  ],
  // 提出確認区分
  docConfirmFlg: [
    { code: 'enum_1', value: '1', text: '提出' },
    { code: 'enum_2', value: '2', text: '確認（連携不要）' },
    { code: 'enum_3', value: '3', text: '確認（連携要）' },
    { code: 'enum_0', value: '0', text: '連携（協力会社）' },
    { code: 'enum_4', value: '4', text: '連携（社内）' },
  ],
  // 指定区分
  specifyFlg: [
    { code: 'enum_0', value: '0', text: '指定なし' },
    { code: 'enum_1', value: '1', text: '限定' },
    { code: 'enum_2', value: '2', text: '不可' },
  ],
  // 日付指定範囲
  dateSpecifyRange: [
    { code: 'enum_1', value: '1', text: '月初（1日～5日）' },
    { code: 'enum_2', value: '2', text: '月末（25日～月末）' },
    { code: 'enum_3', value: '3', text: '上旬（1日～10日）' },
    { code: 'enum_4', value: '4', text: '中旬（11日～20日）' },
    { code: 'enum_5', value: '5', text: '下旬（21日～月末）' },
    { code: 'enum_6', value: '6', text: '前半（1日～15日）' },
    { code: 'enum_7', value: '7', text: '後半（16日～月末）' },
  ],
  // 時間指定条件
  timeSpecifyCondition: [
    { code: 'enum_1', value: '1', text: '開始時間を指定' },
    { code: 'enum_2', value: '2', text: '終了時間を指定' },
    { code: 'enum_3', value: '3', text: '時間範囲を指定' },
    { code: 'enum_4', value: '4', text: '午前指定' },
    { code: 'enum_5', value: '5', text: '午後指定' },
  ],
  // お知らせ文期日単位
  notifyLimitUnit: [
    { code: 'enum_1', value: '1', text: 'ヶ月前' },
    { code: 'enum_2', value: '2', text: '週間前' },
  ],
  // お知らせ文宛先
  notifyDestination: [
    { code: 'enum_1', value: '1', text: '管理事務室' },
    { code: 'enum_2', value: '2', text: '担当支店' },
  ],
  // 報告書宛先
  reportDestination: [
    { code: 'enum_1', value: '1', text: 'パートナーサポート課' },
    { code: 'enum_2', value: '2', text: '担当支店' },
  ],
  // 報告書配送
  reportShipFlag: [
    { code: 'enum_1', value: '1', text: '必着' },
    { code: 'enum_2', value: '2', text: '配送' },
  ],
  // グループ
  groupValue: [
    { code: 'enum_1', value: '1', text: '0次' },
    { code: 'enum_2', value: '2', text: '0.5次' },
    { code: 'enum_3', value: '3', text: '1次' },
    { code: 'enum_4', value: '4', text: '2次' },
  ],
  // 同日可否フラグ
  sameDayFlg: [
    { code: 'enum_1', value: '1', text: '必須' },
    { code: 'enum_2', value: '2', text: '不可' },
  ],
  // 宛先役割区分
  mailRolesFlg: [
    { code: 'enum_1', value: '1', text: '依頼者' },
    { code: 'enum_2', value: '2', text: '進行担当者' },
    { code: 'enum_3', value: '3', text: 'LC' },
    { code: 'enum_4', value: '4', text: 'FM' },
  ],
  // 作業予実調整ステータス
  wparStatus: [
    { code: 'enum_01', value: '01', text: '発注予定' },
    { code: 'enum_02', value: '02', text: '入力待ち' },
    { code: 'enum_03', value: '03', text: '催促要' },
    { code: 'enum_04', value: '04', text: '催促中' },
    { code: 'enum_05', value: '05', text: '入力済み' },
    { code: 'enum_06', value: '06', text: '日程要変更' },
    { code: 'enum_07', value: '07', text: '確認待ち' },
    { code: 'enum_08', value: '08', text: '確認済み' },
    { code: 'enum_09', value: '09', text: '連絡中' },
    { code: 'enum_blank', value: '  ', text: 'N/A' },
  ],
  // チェック結果
  checkResult: [
    { code: 'enum_1', value: '1', text: 'OK' },
    { code: 'enum_0', value: '0', text: 'NG' },
  ],
  // 作業予実変更依頼フラグ
  changeRequestFlg: [
    { code: 'enum_blank', value: ' ', text: '未依頼' },
    { code: 'enum_1', value: '1', text: 'DLNプッシュ' },
    { code: 'enum_2', value: '2', text: 'DLN変更依頼' },
    { code: 'enum_3', value: '3', text: '協力会社変更依頼' },
    { code: 'enum_4', value: '4', text: '差し戻し' },
    { code: 'enum_8', value: '8', text: '依頼取消' },
    { code: 'enum_9', value: '9', text: '依頼済み' },
  ],
  // 作業予実変更項目
  changeCategory: [
    { code: 'enum_0', value: '0', text: '変更' },
    { code: 'enum_1', value: '1', text: '月変更' },
    { code: 'enum_2', value: '2', text: '追加' },
    { code: 'enum_3', value: '3', text: '連絡' },
    { code: 'enum_4', value: '4', text: '中止' },
  ],
  // 現地確認フラグ（不要つもり）
  localComfirmFlg: [
    { code: 'enum_1', value: '1', text: '現地確認要' },
    { code: 'enum_2', value: '2', text: '現地確認済み' },
    { code: 'enum_blank', value: ' ', text: 'N/A' },
  ],
  // 実施日入力状況
  resultDateInputStatus: [
    { code: 'enum_0', value: '0', text: '未入力' },
    { code: 'enum_1', value: '1', text: '催促中' },
    { code: 'enum_2', value: '2', text: '入力済み' },
  ],
  // 変更フラグ
  changeFlg: [
    { code: 'enum_1', value: '1', text: '追加' },
    { code: 'enum_2', value: '2', text: '変更' },
    { code: 'enum_3', value: '3', text: '中止' },
    { code: 'enum_blank', value: ' ', text: 'N/A' },
  ],
  // 報告書状況
  reportStatus: [
    { code: 'enum_00', value: '00', text: '未提出' },
    { code: 'enum_01', value: '01', text: '協力会社へ催促中' },
    { code: 'enum_02', value: '02', text: '提出済み' },
    { code: 'enum_03', value: '03', text: 'PS課確認済み' },
    { code: 'enum_04', value: '04', text: '管理部差し戻し' },
    { code: 'enum_05', value: '05', text: '管理部確認済み' },
    { code: 'enum_10', value: '10', text: 'LCへ催促中' },
    { code: 'enum_11', value: '11', text: 'LC確認済み（組合確認済み）' },
    { code: 'enum_15', value: '15', text: '行政提出済み' },
    { code: 'enum_16', value: '16', text: '副本受領済み' },
    { code: 'enum_20', value: '20', text: '確認完了' },
    { code: 'enum_21', value: '21', text: '確認済み（移動済み）' },
    { code: 'enum_22', value: '22', text: '確認済み（削除済み）' },
  ],
  // 対応状況
  responseStatus: [
    { code: 'enum_1', value: '1', text: '入力中' },
    { code: 'enum_2', value: '2', text: '登録完了（不具合あり）' },
    { code: 'enum_3', value: '3', text: '登録完了（不具合なし）' },
  ],
  // 点検結果
  inspectionStatus: [
    { code: 'enum_0', value: '0', text: '前回同様' },
    { code: 'enum_1', value: '1', text: '改修済み' },
    { code: 'enum_2', value: '2', text: '確認不可能' },
    { code: 'enum_3', value: '3', text: '今回発生不具合' },
  ],
  // 未実施区分
  unimplementClass: [
    { code: 'enum_00', value: '00', text: 'N/A' },
    { code: 'enum_01', value: '01', text: '不在' },
    { code: 'enum_02', value: '02', text: '辞退' },
    { code: 'enum_03', value: '03', text: '空室' },
  ],
  // 報告書形式
  reportFormat: [
    { code: 'enum_1', value: '1', text: '速報版＋正式版' },
    { code: 'enum_2', value: '2', text: '速報版＝正式版' },
    { code: 'enum_3', value: '3', text: '報告書不要' },
  ],
  // 報告書種類フラグ
  reportTypeFlag: [
    { code: 'enum_0', value: '0', text: '速報' },
    { code: 'enum_1', value: '1', text: '正式' },
    { code: 'enum_2', value: '2', text: '原価見積書' },
    { code: 'enum_9', value: '9', text: 'その他' },
  ],
  // 不具合管理フラグ
  defectFlag: [
    { code: 'enum_1', value: '1', text: '不具合情報' },
    { code: 'enum_2', value: '2', text: '不具合情報＋住戸登録' },
    { code: 'enum_3', value: '3', text: '不具合情報＋総合設備点検' },
    { code: 'enum_4', value: '4', text: '不具合不要' },
  ],
  // 正式版確認区分
  officalConfrimClass: [
    { code: 'enum_1', value: '1', text: 'PS課' },
    { code: 'enum_2', value: '2', text: 'PS課＆管理部' },
    { code: 'enum_3', value: '3', text: '管理部' },
    { code: 'enum_4', value: '4', text: '法定' },
  ],
  // 進捗対象区分
  progessTargetClass: [
    { code: 'enum_1', value: '1', text: 'EV' },
    { code: 'enum_2', value: '2', text: '建築' },
    { code: 'enum_3', value: '3', text: '植栽' },
    { code: 'enum_4', value: '4', text: '清掃' },
    { code: 'enum_5', value: '5', text: '消防' },
    { code: 'enum_6', value: '6', text: 'その他' },
  ],
  // 指摘有無
  indicateFlag: [
    { code: 'enum_0', value: '0', text: '指摘無し' },
    { code: 'enum_1', value: '1', text: '指摘あり' },
  ],
  // 検索区分
  queryClass: [
    { code: 'enum_1', value: '1', text: '商品明細別パターン' },
    { code: 'enum_2', value: '2', text: '作業仕様別パターン' },
    { code: 'enum_3', value: '3', text: '商品明細別テンプレート' },
  ],
  // プッシュ区分
  pushType: [
    { code: 'enum_1', value: '1', text: '未入力' },
    { code: 'enum_2', value: '2', text: '不可日' },
  ],
  // 既読フラグ
  readFlg: [
    { code: 'enum_0', value: '0', text: '未読' },
    { code: 'enum_1', value: '1', text: '既読' },
  ],
  // 北関返送状況
  northSendStatus: [
    { code: 'enum_1', value: '1', text: '未返送' },
    { code: 'enum_2', value: '2', text: '返送済み' },
  ],
  // 断水仕様区分
  waterOutageType: [
    { code: 'enum_1', value: '1', text: '断水有' },
    { code: 'enum_2', value: '2', text: '断水不可' },
  ],
  // 同日可否フラグ
  samedayFlg: [
    { code: 'enum_1', value: '1', text: '必須' },
    { code: 'enum_2', value: '2', text: '不可' },
  ],
  // 作成元区分
  workOriginClass: [
    { code: 'enum_0', value: '0', text: 'clombs' },
    { code: 'enum_1', value: '1', text: 'order' },
  ],
  // 写真受取区分
  photoReceiveFlag: [
    { code: 'enum_blank', value: ' ', text: '未取得' },
    { code: 'enum_1', value: '1', text: '取得済み' },
  ],
  // 削除もの含む
  deletedContainFlag: [
    { code: 'enum_0', value: '0', text: '削除済データを含まない' },
    { code: 'enum_1', value: '1', text: '削除済データを含む' },
  ],
  // 調整不要もの含む
  adjustedContainFlag: [
    { code: 'enum_0', value: '0', text: '日程調整不要を含まない  ' },
    { code: 'enum_1', value: '1', text: '日程調整不要を含む' },
  ],
  // 管理部門
  manageDept: [
    { code: 'enum_E', value: 'E', text: 'パートナーサポート課(東日本)' },
    { code: 'enum_W', value: 'W', text: 'パートナーサポート課(西日本)' },
  ],
  // 様式
  formStyle: [
    { code: 'enum_1', value: '1', text: '総合設備データリスト' },
    { code: 'enum_2', value: '2', text: '総合設備点検不具合詳細' },
  ],
  // 点検可否区分
  checkableFlg: [
    { code: 'enum_1', value: '1', text: '点検可' },
    { code: 'enum_0', value: '0', text: '点検不可' },
  ],
  // 建物管理形態
  bulidingManageForm: [
    { code: 'enum_2', value: '2', text: '通勤' },
    { code: 'enum_0', value: '0', text: '通勤以外' },
  ],
}
